import dayjs from "dayjs";

export function euro(value) {
  const options = { style: "currency", currency: "EUR" };
  return Intl.NumberFormat("es-ES", options).format(Math.round(value || 0));
}

export function fraction(value) {
  return new Intl.NumberFormat("es-ES", {
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  }).format(value || 0);
}

export function date(value) {
  if (!value) return "-";

  return dayjs(value).format("DD/MM/YYYY");
}
